import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './EmptyState.module.css';

export type EmptyStateProps = {
  title?: string;
  description?: ReactNode;
  action?: ReactNode;
  illustration?: ReactNode;
  /** `compact` — denser copy block for in-table / panel overlays. */
  density?: 'default' | 'compact';
};

export function EmptyState({
  title = 'Rien à afficher',
  description,
  action,
  illustration,
  density = 'default',
}: EmptyStateProps) {
  return (
    <div className={cx(styles.wrap, density === 'compact' && styles.wrapCompact)}>
      {illustration ? <div className={styles.illustration}>{illustration}</div> : null}
      <div className={styles.title}>{title}</div>
      {description ? <div className={styles.description}>{description}</div> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
